import { deburr, sortBy } from 'lodash';
import { getName, getNames, registerLocale } from 'i18n-iso-countries';
import { i18n, getLanguageFromLocale } from '../i18n/i18n';

export default {
    async loadCountriesLanguage(language) {
        let countryLangJson;
        switch (language) {
            case 'pl':
                countryLangJson = await import('i18n-iso-countries/langs/pl.json');
                break;
            case 'en-GB':
                countryLangJson = await import('i18n-iso-countries/langs/en.json');
                break;
            // inne języki
            default:
                console.error(`Country locale file for "${language}" not found.`);
                return;
        }

        if (countryLangJson) {
            registerLocale(countryLangJson.default);
        }
    },

    getCountryOptions() {
        const language = getLanguageFromLocale(i18n.locale);
        const allCountries = getNames(language);
        const options = Object.keys(allCountries).map(countryCode => ({
            value: countryCode,
            text: allCountries[countryCode],
        }));

        // deburr is used to handle accented characters during sort
        return sortBy(options, option => deburr(option.text));
    },

    getCountryName(code) {
        const language = getLanguageFromLocale(i18n.locale);
        return getName(code, language);
    },

    getBankAccountPrefixes() {
        const language = getLanguageFromLocale(i18n.locale);
        const allCountries = getNames(language);
        const options = Object.keys(allCountries).map(countryCode => ({
            value: countryCode,
            text: countryCode,
        }));
        return sortBy(options, option => deburr(option.text));
    },
};
